import React, { useState } from 'react';
import { Button, Grid, TextField, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { requestPutPayoutOnHold } from '../../../request/invoiceRequests';
import Busy from "../../../../Busy";
import { CallbackActions } from "../../../../../util/ActionUtils";
import {getErrorMessageForStandardResponse} from "../../../../../util/NetworkErrorUtil";
import {useSnackbar} from "../../../../../context/snackbar-context";

const RequestPayoutOnHoldModal = (props: {
  invoice: {transactionId: string; transactionNumber: string},
  open: boolean,
  onInvoiceAction: (callbackActions?: string, invoice?: {transactionId: string}, message?: string) => void,
  onClose: (callbackActions?: string, invoice?: {transactionId: string}, message?: string) => void,
}) => {
  const { invoice, open, onInvoiceAction, onClose } = props;

  const [statusNotes, setStatusNotes] = useState<string>('');
  const { snackbarShowMessage } = useSnackbar();

  const onSubmit = (event: {preventDefault: () => {}}) => {
    event.preventDefault();

    if(!statusNotes) {
      snackbarShowMessage("Please provide a reason", 'error');
      return;
    }
    Busy.set(true);
    requestPutPayoutOnHold(invoice, statusNotes).then(() => {
      onClose(CallbackActions.SUCCESS, invoice, `Successfully placed invoice ${invoice.transactionNumber} on hold.`);
    }).catch((error) => {
      onInvoiceAction(CallbackActions.ERROR, invoice, getErrorMessageForStandardResponse(error, ""));
    }).finally(() => {
      setStatusNotes('')
      Busy.set(false);
    });
  };

  const handleClose = () => {
    onClose();
    setStatusNotes('');
  };

  const updateStatus = (event: {target: {value: string}}) => {
    setStatusNotes(event.target.value)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: 'form',
        onSubmit
      }}
    >
      <DialogTitle>
        Put Payout {invoice?.transactionNumber} on Hold
      </DialogTitle>
      <DialogContent>
        <TextField
          id="outlined-multiline-static"
          name="reason"
          label="Reason for Hold"
          helperText="Enter the reason for placing this payout on hold."
          value={statusNotes}
          onChange={updateStatus}
          fullWidth
          variant="standard"
        />
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent={"center"}>
          <Button variant="text" onClick={handleClose} >Cancel</Button>
          <Button variant="contained" type="submit">Submit</Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
export default RequestPayoutOnHoldModal;
